// The dashboard designer: coming to TUNE Analytics. Until it's here, the page says what it will do, and how
// dashboards reach the MFD meanwhile.
import { Page } from '../../shell/Page';
import { Card, ListLink, ListSection } from '../../ui';
import { BooksIcon, PaletteIcon, UploadSimpleIcon } from '../../ui/icons';
import s from './CreateHub.module.css';

export function Dashboards() {
  return (
    <Page
      title="Dashboard designer"
      back={{ to: '/create', label: 'Create' }}
      width="narrow"
      subtitle="Coming to TUNE Analytics: dashboards for the TUNE MFD, designed in your browser."
    >
      <Card title="What it will do">
        <ul className={s.points}>
          <li>Start from one of your dashboards, one of TUNE's, or a blank page at the MFD's 1440 × 720.</li>
          <li>Place gauges, text, images and the lap timer, and choose their values, colours and alarms.</li>
          <li>See it as the MFD draws it, with values playing from one of your datalogs.</li>
          <li>Save it to your library as a .tunetheme file. Your MFDs get it at their next sync.</li>
        </ul>
      </Card>
      <ListSection
        header="Meanwhile"
        footer="On the MFD, Quick settings › Edit gauges changes the gauges on screen. A dashboard changed there comes to your library by itself."
      >
        <ListLink to="/library" icon={<PaletteIcon size={20} weight="bold" />} label="Your dashboards" />
        <ListLink
          to="/library?sheet=add"
          icon={<UploadSimpleIcon size={20} weight="bold" />}
          label="Add a dashboard file"
        />
        <ListLink to="/library/catalogue" icon={<BooksIcon size={20} weight="bold" />} label="TUNE's dashboards" />
      </ListSection>
    </Page>
  );
}
